// mds-dojo — dijit/_editor/plugins/NewPage — FAITHFUL port of
// references/dijit/_editor/plugins/NewPage.js. Resets editor content to a default string.
// Registers itself into _Plugin.registry ("newPage" / "newpage").
//
// ADAPTATIONS: import paths repathed; `dojo/_base/declare` → declare-runtime;
//   `dojo/i18n!../nls/commands` + i18n.getLocalization inlined (only "newPage" is used).
import declare from '../../../dojo/_base/declare-runtime'; // declare
import lang from '../../../dojo/_base/lang'; // lang.hitch
import _Plugin from '../_Plugin';
import Button from '../../form/Button';

// Inlined from dijit/_editor/nls/commands (root locale).
var strings: any = { newPage: "New Page" };

// module:
//		dijit/_editor/plugins/NewPage

var NewPage: any = declare("dijit._editor.plugins.NewPage", _Plugin, {
	// summary:
	//		This plugin provides a simple 'new page' capability.  In other
	//		words, set content to some default user defined string.

	// content: [public] String
	//		The default content to insert into the editor as the new page.
	//		The default is the `<br>` tag, a single blank line.
	content: "<br>",

	_initButton: function(){
		// summary:
		//		Over-ride for creation of the Print button.
		var editor = this.editor;
		this.button = new Button({
			label: strings["newPage"],
			ownerDocument: editor.ownerDocument,
			dir: editor.dir,
			lang: editor.lang,
			showLabel: false,
			iconClass: this.iconClassPrefix + " " + this.iconClassPrefix + "NewPage",
			tabIndex: "-1",
			onClick: lang.hitch(this, "_newPage")
		});
	},

	setEditor: function(/*dijit/Editor*/ editor: any){
		// summary:
		//		Tell the plugin which Editor it is associated with.
		// editor: Object
		//		The editor object to attach the newPage capability to.
		this.editor = editor;
		this._initButton();
	},

	updateState: function(){
		// summary:
		//		Over-ride for button state control for disabled to work.
		this.button.set("disabled", this.get("disabled"));
	},

	_newPage: function(){
		// summary:
		//		Function to set the content to blank.
		// tags:
		//		private
		this.editor.beginEditing();
		this.editor.set("value", this.content);
		this.editor.endEditing();
		this.editor.focus();
	}
});

// Register this plugin.
// For back-compat accept "newpage" (all lowercase) too, remove in 2.0
_Plugin.registry["newPage"] = _Plugin.registry["newpage"] = function(args: any){
	return new NewPage({
		content: ("content" in args) ? args.content : "<br>"
	});
};

export default NewPage;
